import React from 'react';
import { Link } from 'react-router-dom';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import { Card, EmptyState, LoadingSkeleton } from '../ui';
import useApi from '../portal/useApi';
import { formatMoney, formatPercent, termLabel, classLabel } from '../portal/format';
import styles from '../portal/Portal.module.css';

function attendanceTone(rate) {
  if (rate === null || rate === undefined) return '';
  if (rate >= 90) return styles.statGood;
  return rate >= 75 ? styles.statWarn : styles.statBad;
}

// The parent's home screen: one card per linked child, each opening that
// child's detail page.
function ParentDashboard({ token, user }) {
  const { data, loading, error } = useApi(token, '/api/v1/parent/children');
  const children = data?.children || [];
  const features = user?.features || {};

  return (
    <div>
      <div className={styles.header}>
        <div>
          <h2 className={styles.title}>My Children</h2>
          <p className={styles.subtitle}>
            {data?.current_term ? `${termLabel(data.current_term)} · ` : ''}Select a child to see their reports, attendance and fees.
          </p>
        </div>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <LoadingSkeleton type="card" rows={2} />
      ) : children.length === 0 && !error ? (
        <Card>
          <EmptyState
            title="No children linked to your account yet"
            message="Please contact the school office so they can link your children to this login."
            icon={<UserGroupIcon />}
          />
        </Card>
      ) : (
        <div className={styles.grid}>
          {children.map((child) => (
            <Link key={child.id} to={`/my-children/${child.id}`} className={styles.tileLink}>
              <div>
                <div className={styles.tileName}>{child.full_name}</div>
                <div className={styles.tileMeta}>{classLabel(child)}</div>
              </div>
              <div className={styles.stats}>
                {features.attendance !== false && (
                  <div className={styles.stat}>
                    <div className={styles.statLabel}>Attendance this term</div>
                    <div className={`${styles.statValue} ${attendanceTone(child.attendance_rate)}`}>{formatPercent(child.attendance_rate)}</div>
                  </div>
                )}
                {features.fees !== false && (
                  <div className={styles.stat}>
                    <div className={styles.statLabel}>Fees outstanding</div>
                    <div className={`${styles.statValue} ${child.balance_usd > 0 ? styles.statBad : styles.statGood}`}>{formatMoney(child.balance_usd)}</div>
                  </div>
                )}
              </div>
              <div className={styles.tileFooter}>View details →</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default ParentDashboard;
